/* Vegan LifeMoss shop-all / collection page: goal filter, sort, size + subscribe toggle, quick add. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function fmt(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function initCard(card) {
    var sel = card.querySelector('[data-cl-variant]');
    var sub = card.querySelector('[data-cl-sub]');
    var btn = card.querySelector('[data-cl-add]');
    var now = card.querySelector('[data-cl-now]');
    var was = card.querySelector('[data-cl-was]');
    var day = card.querySelector('[data-cl-day]');
    var days = +card.getAttribute('data-days') || 0;
    if (!btn) return;
    function current() {
      var o = sel ? sel.options[sel.selectedIndex] : null;
      return {
        id: o ? o.value : btn.getAttribute('data-variant'),
        price: +(o ? o.getAttribute('data-price') : card.getAttribute('data-price')),
        sub: +(o ? o.getAttribute('data-sub') : btn.getAttribute('data-sub')) || 0,
        plan: o ? o.getAttribute('data-plan') : btn.getAttribute('data-plan')
      };
    }
    function render() {
      var c = current();
      var on = sub && sub.checked && c.plan && c.sub;
      var p = on ? c.sub : c.price;
      if (now) now.textContent = fmt(p);
      if (was) { was.textContent = fmt(c.price); was.hidden = !on; }
      if (day && days) day.textContent = fmt(p / days);
      if (sub) { var lab = sub.closest('.vh-cl__sub'); if (lab) lab.hidden = !c.plan; }
      card.setAttribute('data-price', c.price);
    }
    if (sel) sel.addEventListener('change', render);
    if (sub) sub.addEventListener('change', render);
    var label = btn.innerHTML;
    btn.addEventListener('click', function () {
      var c = current();
      var item = { id: +c.id, quantity: 1 };
      if (sub && sub.checked && c.plan) item.selling_plan = +c.plan;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          btn.disabled = false; btn.textContent = 'Added ✓';
          setTimeout(function () { btn.innerHTML = label; }, 2000);
          try { if (window.upcartRefreshCart) window.upcartRefreshCart(); if (window.upcartOpenCart) { window.upcartOpenCart(); return; } } catch (e) {}
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function (err) {
          btn.disabled = false; btn.innerHTML = label;
          var n = card.querySelector('.vh-cl__err') || document.createElement('p');
          n.className = 'vh-cl__err'; n.setAttribute('role', 'alert');
          n.textContent = (err && (err.description || err.message)) || 'Sorry, that could not be added.';
          card.querySelector('.vh-card__body').appendChild(n);
        });
    });
    render();
  }

  function initPage(wrap) {
    if (wrap.__cl) return; wrap.__cl = true;
    var grid = wrap.querySelector('[data-cl-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-cl-card]'));
    var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-cl-tile]'));
    var chips = Array.prototype.slice.call(wrap.querySelectorAll('.vh-cl__chip'));
    var sortSel = wrap.querySelector('[data-cl-sort]');
    var count = wrap.querySelector('[data-cl-count]');
    var empty = wrap.querySelector('[data-cl-empty]');
    var goal = '';
    cards.forEach(initCard);

    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var g = ' ' + (c.getAttribute('data-goals') || '') + ' ';
        var show = !goal || g.indexOf(' ' + goal + ' ') > -1;
        c.hidden = !show; if (show) n++;
      });
      var mode = sortSel ? sortSel.value : 'featured';
      var sorted = cards.slice().sort(function (a, b) {
        var oa = a.getAttribute('data-avail') === 'true' ? 0 : 1, ob = b.getAttribute('data-avail') === 'true' ? 0 : 1;
        if (oa !== ob) return oa - ob;
        var d = 0;
        if (mode === 'rating') d = (+b.getAttribute('data-rating')) - (+a.getAttribute('data-rating'));
        else if (mode === 'price-asc') d = (+a.getAttribute('data-price')) - (+b.getAttribute('data-price'));
        else if (mode === 'price-desc') d = (+b.getAttribute('data-price')) - (+a.getAttribute('data-price'));
        if (!d) d = (+a.getAttribute('data-rank')) - (+b.getAttribute('data-rank'));
        return d || (+a.getAttribute('data-index')) - (+b.getAttribute('data-index'));
      });
      sorted.forEach(function (c) { grid.appendChild(c); });
      // promo tiles: after the 3rd and 7th product, only on the unfiltered Featured view
      var showTiles = !goal && mode === 'featured';
      tiles.forEach(function (t) {
        t.hidden = !showTiles;
        var mob = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
        var after = sorted[t.classList.contains('vh-cl__tile--bundle') ? (mob ? 3 : 2) : (mob ? 7 : 6)];
        if (showTiles && after) after.insertAdjacentElement('afterend', t); else grid.appendChild(t);
      });
      if (count) count.textContent = n;
      if (empty) empty.hidden = n > 0;
      chips.forEach(function (ch) { ch.setAttribute('aria-pressed', String((ch.getAttribute('data-cl-goal') || '') === goal)); });
      try {
        var u = new URL(window.location.href);
        if (goal) u.searchParams.set('goal', goal); else u.searchParams.delete('goal');
        window.history.replaceState(null, '', u.toString());
      } catch (e) {}
    }
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cl-goal]');
      if (!b || !wrap.contains(b)) return;
      goal = b.getAttribute('data-cl-goal') || '';
      apply();
    });
    if (sortSel) sortSel.addEventListener('change', apply);
    try {
      var q = new URL(window.location.href).searchParams.get('goal');
      if (q && chips.some(function (c) { return c.getAttribute('data-cl-goal') === q; })) goal = q;
    } catch (e) {}
    apply();
  }

  function boot() { document.querySelectorAll('[data-cl]').forEach(initPage); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
